export const frontendurls = {
  AddImage:"/add-image",
  EditImage:"/edit-image",
  ListImages:"/list-images",
  PendingRequests:"/pending-requests",
  AllPendingRequests:"/all-pending-requests",
  ViewCollections:"/view-collections",
  Register:"/registration",
  UserLogin:"/login",
  AdminLogin:"/admin-login",
  AdminListing:"/admin-users",
  ForgotPassword:"/forgot-password",
  ResetPassword:"/reset-password",
  ResetPasswordLink:"reset-password",
  AdminEdit:"/edit-admin",
  Home:"/home",
  Profile:"/my-profile",
  ViewImages:"/view-images",
  AdminDashboard:"/admin-dashboard",
  AdminHome:"admin-dashboard",
  ViewWishlist:"/view-wishlist",
  PendingRequestDetails:"/request-details",
  OtherPendingRequests:"/other-pending-requests",
  UserListing: "/website-users",
  PreviousRequestList:"/previous-requests",
  UserRequests:"/user-requests",
  ImageRequests:"/image-requests",
  PrivacyPolicy: "/privacy-policy",
  MyRequests:"/my-requests",
  AllUserRequests:"/all-requests",
  FAQs: "/faqs",
  ListBooks:"/list-books",
  ListCategories:"/list-categories",
  FilterImages:"/filter-images",
  ImageExtractor:"/"
}